import React, { Component } from 'react';
import styled from 'styled-components';
import api from 'api';
import moment from 'moment';

import { capitalize, scrollWindowTo } from 'helpers';
import WP from 'WP';

import SuccessForm from './SuccessForm';
import ContactForm from './ContactForm';
import Checkbox from './Checkbox';
import DatePicker from './DatePicker';
import DropdownList from './DropdownList';
import TextArea from './TextArea';
import GridElement from 'partials/GridElement';
import Html from 'partials/Html';
import Button from 'partials/Button';

import Media from 'css/Media';

const numDays = [
    {label: "1", value: 1},
    {label: "2", value: 2},
    {label: "3", value: 3},
    {label: "4", value: 4},
    {label: "5", value: 5},
    {label: "6", value: 6},
    {label: "7", value: 7},
    {label: "8", value: 8},
    {label: "9", value: 9},
    {label: "10", value: 10},
    {label: WP.trans.moreThanTen, value: 11},
]

class EquipmentRentalForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            personalia: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                adress: '',
                postalCode: '',
                city: '',
            },
            products: [],
            disabled: false,
            date: null,
            days: 1,
            dateValid: true,
            message: '',
        }
        this.datePickr = React.createRef();
    }

    handleOnChange = e => {
        let name = e.target.name;
        let value = e.target.value;

        this.setState({personalia: {...this.state.personalia, [name]: value}});
    }

    handleDropdownChange = value => {
        this.setState({days: value})
    }

    handleInputChange = e => {
        let name = e.target.name;
        let value = e.target.value;

        this.setState({ [name]: value });
    }

    handleCheck = e => {
        let { products } = this.state;
        let target = e.target.name;

        if(products.includes(target)) {
            products.splice(products.indexOf(target), 1)
        } else {
            products.push(target)
        }
        this.setState({products: products})
    }

    setDate = dateObj => {
        let string = capitalize(moment(new Date(dateObj)).format('dddd D. MMM. YYYY,'));
        this.setState({date: dateObj, dateStr: string, dateValid: true})
    }

    getDayPrice = price => {
        return (
            `NOK ${price.toLocaleString('fr')}`
        )
    }

    getWeekPrice = price => {
        return (
            `NOK ${price.toLocaleString('fr')}`
        )
    }

    validateFields = () => {
        const { personalia, products, date } = this.state;
        let contact = document.getElementById('contact_form');
        let order_form = document.getElementById('equipment_order_form');

        if(products) {
            if(date) {
                if(
                    personalia.firstName.length > 0 && 
                    personalia.lastName.length > 0 && 
                    personalia.email.length > 0 && 
                    personalia.phone.length > 0 && 
                    personalia.adress.length > 0 && 
                    personalia.postalCode.length > 0 && 
                    personalia.city.length > 0
                ){
                    this.getPrice();
                } else {
                    window.scrollTo({
                        top:  window.scrollY + contact.getBoundingClientRect().top,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            } else {
                this.setState({dateValid: false})
                window.scrollTo({
                    top:  window.scrollY + order_form.getBoundingClientRect().top,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        } else {
            window.scrollTo({
                top:  window.scrollY + order_form.getBoundingClientRect().top,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    getPrice = () => {
        let rentals = this.props.products;
        let products = this.state.products;
        let order = [];
        let arr = [];

        rentals.map(rental => {
            products.map(product => {
                if(product == rental.id) {
                    arr.push(rental);
                }
                return null;
            })
            return null;
        })

        arr.map(product => {
            let rental = {
                    name: product.title.rendered,
                    rentalPrice: [],
                    total: [],
                };
            //set discouted price if product is rented for a week or longer
            if(this.state.days >= 7) {
                rental.rentalPrice.push(parseInt((product.acf.price_week / 7) * this.state.days));
                rental.total.push(parseInt((product.acf.price_week / 7) * this.state.days));
            //if more than one day, add reduced price
            } else if(product.acf.day_rate_following) {
                rental.rentalPrice.push(parseInt(product.acf.day_rate), parseInt(product.acf.day_rate_following * (this.state.days - 1)));
                rental.total.push(parseInt(product.acf.day_rate), parseInt(product.acf.day_rate_following * (this.state.days - 1)));
            } else {
                rental.rentalPrice.push(parseInt(product.acf.day_rate));
                rental.total.push(parseInt(product.acf.day_rate));
            }

            rental.rentalPrice = rental.rentalPrice.reduce((acc, num) => acc + num);
            rental.total = rental.total.reduce((acc, num) => acc + num);
            order.push(rental);
            return null;
        })

        this.setState({order: order},() => this.handleSubmit())
    }

    handleSubmit = () => {
        return Promise.all([
            this.onHandleSendRentalRequest(),
            this.onHandleSendConfirmationEmail(),
        ]).then(() => {
            this.displaySuccess();
        }).catch(error => {

        });
    }

    onHandleSendRentalRequest = () => {
        const parameters = {
            bookingEmail: this.props.booking_email,
            products: this.state.order,
            date: moment(new Date(this.state.date)).format('DD-MM-YYYY'),
            days: this.state.days,
            message: this.state.message,
            name: this.state.personalia.firstName + ' ' + this.state.personalia.lastName,
            phone: this.state.personalia.phone,
            email: this.state.personalia.email,
            adress: this.state.personalia.adress,
            postalCode: this.state.personalia.postalCode,
            city: this.state.personalia.city,
        }

        return api.sendEquipmentRentalRequest(parameters);
    }

    onHandleSendConfirmationEmail = () => {
        const parameters = {
            email: this.state.personalia.email,
            products: this.state.order,
            date: moment(new Date(this.state.date)).format('DD-MM-YYYY'),
            days: this.state.days,
            message: this.state.message,
            name: this.state.personalia.firstName + ' ' + this.state.personalia.lastName,
            phone: this.state.personalia.phone,
            email: this.state.personalia.email,
            adress: this.state.personalia.adress,
            postalCode: this.state.personalia.postalCode,
            city: this.state.personalia.city,
        };

        return api.sendEquipmentRentalOrderConfirmation(parameters)
    }

    displaySuccess = () => {
        let form = document.getElementById('form');

        window.scrollTo({
            top:  window.scrollY + form.getBoundingClientRect().top,
            left: 0,
            behavior: 'smooth'
        });
        this.setState({submitted: true})
    }

    

    render() {
        const { form_title, form_text_content, products, } = this.props;
        const {
            days,
            personalia,
            validEmailFormat,
            disabled,
            dateValid,
            submitted,
            message,
            order,
        } = this.state;

        //console.log(this.state)
        return (
            <React.Fragment>
                { !submitted ?
                    <FormGrid id="form">
                    <TitleGridElement
                        id="equipment_order_form"
                        colStart={{default: 1, s: 3, m: 3}}
                        colEnd={{default: 8, s: 14, m: 14}}
                        rowStart={1}
                    >
                        <h2>{form_title}</h2>
                    </TitleGridElement>
                    <GridElement
                        colStart={{default: 1, s: 3, m: 3}}
                        colEnd={{default: 8, s: 14, m: 14}}
                        rowStart={2}
                    >
                        <ProductGrid>
                            { products ? products.map((product,idx) => {
                                return(
                                    <ProductGridElement
                                        colStart={{default: 1, s: 1}}
                                        colEnd={{default: 8, s: 12}}
                                        rowStart={{default: 'auto'}}
                                    >
                                        <ProductTitle>{product.acf.title}</ProductTitle>
                                        { product.acf.day_rate ?
                                            <PricePoint>
                                                <span>{ WP.trans.pricePerDay}</span>
                                                <span>{this.getDayPrice(product.acf.day_rate)}</span>
                                            </PricePoint> : null
                                        }
                                        { product.acf.day_rate_following ?
                                            <PricePoint>
                                                <span>{ WP.trans.pricePerFollowingDay}</span>
                                                <span>{this.getDayPrice(product.acf.day_rate_following)}</span>
                                            </PricePoint> : null
                                        }
                                        { product.acf.price_week ?
                                            <PricePoint>
                                                <span>{WP.trans.pricePerWeek}</span>
                                                <span>{this.getWeekPrice(product.acf.price_week)}</span>
                                            </PricePoint> : null
                                        }
                                        <Checkbox
                                            name={product.id} 
                                            text={capitalize(WP.trans.choose)} 
                                            onChange={this.handleCheck}
                                        />
                                    </ProductGridElement>
                                )
                            }) : null}
                        </ProductGrid>
                    </GridElement>
                    <DatePickerGridElement
                        colStart={{default: 1, s: 3, m: 3}}
                        colEnd={{default: 8, s: 14, m: 8}}
                        rowStart={{default: 3}}
                    >
                        <DatePicker
                            dateHandler={(dateObjects, dateStr, instance) => this.setDate(dateObjects, dateStr, instance)}
                            reference={this.datePickr}
                            valid={dateValid}
                        />
                    </DatePickerGridElement>
                    <DaysGridElement
                        colStart={{default: 1, s: 3, m: 9}}
                        colEnd={{default: 8, s: 14, m: 14}}
                        rowStart={{default: 4, s: 4, m: 3}}
                    >
                        <DropdownList 
                            name="days"
                            onChange={this.handleDropdownChange}
                            options={numDays}
                            label={WP.trans.numDays}
                        />
                    </DaysGridElement>
                    <GridElement
                        colStart={{default: 1, s: 3}}
                        colEnd={{default: 8, s: 14}}
                        rowStart={{default: 5, m: 4}}
                    >
                        <TextArea 
                            name="message"
                            onChange={this.handleInputChange}
                            label={WP.trans.messageToBooking}
                            value={message}
                        />
                    </GridElement>
                    <DividerGridElement
                        colStart={{default: 1, s: 1, m: 1}}
                        colEnd={{default: 8, s: 16, m: 16}}
                        rowStart={{default: 6, m: 5}}
                    />
                    <GridElement
                        id="contact_form"
                        colStart={{default: 1, s: 1}}
                        colEnd={{default: 8, s: 16}}
                        rowStart={{default: 7, m: 6}}
                    >
                        <ContactForm
                            personalia={personalia}
                            handleOnChange={this.handleOnChange}
                            validateEmailFormat={this.validateEmailFormat}
                            validEmailFormat={validEmailFormat}
                        />
                    </GridElement>
                    { form_text_content &&
                        <HtmlGridElement
                            colStart={{default: 1, s: 3}}
                            colEnd={{default: 8, s: 14}}
                            rowStart={{default: 8, m: 7}}
                        >
                        <Html content>{form_text_content}</Html>
                    </HtmlGridElement>}
                    <InputGridElement
                        colStart={{default: 1, s: 5, m: 11}}
                        colEnd={{default: 4, s: 12, m: 14}}
                        colSpan
                        rowStart={{default: 9, m: 8}}
                        align="center"
                    >
                        <Button 
                            onClick={disabled ? null : () => this.validateFields()} 
                            tabIndex={1}
                        >
                            { submitted ? 
                                WP.trans.thanks : 
                                WP.trans.sendReservation
                            }
                        </Button>
                    </InputGridElement>
                </FormGrid>
                : <SuccessForm 
                    rentals={order} 
                    date={this.state.dateStr}
                    days={days}
                    personalia={personalia}
                />}
        </React.Fragment>
        )
    }
}


export default EquipmentRentalForm;

const FormGrid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
    -ms-grid-rows: ${props => props.rows || 'auto'};
    grid-template-rows: ${props => props.rows || 'auto'};
    margin-bottom: ${props => props.theme.spacing.elementM};

    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .67fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .67fr) 1fr;
        padding: ${props => props.theme.spacing.elementL} 0 ${props => props.theme.spacing.blockM};
        margin-bottom: ${props => props.theme.spacing.blockL};
        border: 1px solid ${props => props.theme.colors.text};
    `}

    ${Media.greaterThan('m')`
        -ms-grid-columns: (1fr .435fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .435fr) 1fr;
    `}

    h2 {
        font-size: 20px;
        line-height: 27px;
      
        ${Media.greaterThan('s')`
            ${props => props.theme.fonts.h4}  
        `}
    }
`

const ProductGrid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
    -ms-grid-rows: ${props => props.rows || 'auto'};
    grid-template-rows: ${props => props.rows || 'auto'};

    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .67fr)[5] 1fr;
        grid-template-columns: repeat(5, 1fr .67fr) 1fr;
    `}

    ${Media.greaterThan('m')`
        -ms-grid-columns: (1fr .435fr)[5] 1fr;
        grid-template-columns: repeat(5, 1fr .435fr) 1fr;
    `}
`

const TitleGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementM};
    `}
`

const HtmlGridElement = styled(GridElement)`

    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.blockXS};
    `}
`

const DividerGridElement = styled(GridElement)`
    width: 100%;
    padding-top: ${props => props.theme.spacing.elementL};
    margin-bottom: 0;

    ${Media.greaterThan('s')`
        border-bottom: 1px solid ${props => props.theme.colors.lines};
        padding-top: ${props => props.theme.spacing.blockS};
        margin-bottom: ${props => props.theme.spacing.blockS};
    `}
`

const InputGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};
    
    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};

        &:last-of-type {
            padding-bottom: ${props => props.theme.spacing.elementM};
        }
    `}
`

const ProductGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};
    font-size: 14px;
    line-height: 23px;

    &:last-of-type {
        padding-bottom: ${props => props.theme.spacing.blockS};
    }
    
    ${Media.greaterThan('s')`
        font-size: 16px;
        line-height: 25px;

        &:last-of-type {
            padding-bottom: ${props => props.theme.spacing.elementS};
        }
    `}
`

const ProductTitle = styled.span`

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.contentXS};
    `}
`

const PricePoint = styled.div`
    display: flex;
    
    &:last-of-type {
        padding-bottom: ${props => props.theme.spacing.contentL};
    }

    span {
        margin-right: 4px;
    }
`

const DatePickerGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};
    `}
`

const DaysGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};
    `}
`